/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Authorize_HelperInputs */

const en_zotero_authorize_helper = /** @type {(inputs: Zotero_Authorize_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll authorise Listening on zotero.org`)
};

const es_zotero_authorize_helper = /** @type {(inputs: Zotero_Authorize_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorizarás a Listening en zotero.org`)
};

/**
* | output |
* | --- |
* | "You'll authorise Listening on zotero.org" |
*
* @param {Zotero_Authorize_HelperInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_authorize_helper = /** @type {((inputs?: Zotero_Authorize_HelperInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Authorize_HelperInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_authorize_helper(inputs)
	return en_zotero_authorize_helper(inputs)
});